import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import { gettext } from '@eventbrite/i18n';
import { Icon } from '@eventbrite/eds-icon';
import { TABBABLE_INDEX } from '@eventbrite/eds-hot-keys';
import {
    ChevronUpChunky,
    ChevronDownChunky,
} from '@eventbrite/eds-iconography';

const DropLink = React.memo(
    ({
        children,
        fallbackUrl,
        dropUp,
        onClick,
        tabIndex,
        hideDropIconWhenNarrow,
        ariaLabelContent,
        role,
        shouldFocusDropLink,
    }) => {
        const linkRef = useRef(null);

        useEffect(() => {
            if (tabIndex === TABBABLE_INDEX && shouldFocusDropLink) {
                linkRef.current?.focus();
            } else {
                linkRef.current?.blur();
            }
        }, [tabIndex, shouldFocusDropLink]);

        const iconType = dropUp ? <ChevronUpChunky /> : <ChevronDownChunky />;
        const iconClassName = classNames('eds-dropdown-menu__icon', {
            'eds-dropdown-menu__icon--narrow-breakpoints':
                hideDropIconWhenNarrow,
        });

        return (
            <a
                className="eds-dropdown-menu__link ignore-react-onclickoutside"
                href={fallbackUrl}
                onClick={onClick}
                data-spec="dropdown-menu-link"
                role={role ?? 'menuitem'}
                ref={linkRef}
                onMouseEnter={() => linkRef.current?.focus()}
                onMouseLeave={() => linkRef.current?.blur()}
                tabIndex={tabIndex}
                aria-label={
                    children[0]?.props?.label
                        ? children[0]?.props?.label
                        : `${gettext('Dropdown menu').toString()}${
                              ariaLabelContent
                                  ? ` ${gettext(
                                        'with label',
                                    ).toString()} ${ariaLabelContent}`
                                  : ''
                          }`
                }
            >
                <div
                    className="eds-dropdown-menu__contents"
                    data-spec="dropdown-menu-contents"
                >
                    {children}
                </div>
                <span className={iconClassName}>
                    <Icon
                        type={iconType}
                        color="grey-400"
                        isBlockLevel={true}
                    />
                </span>
            </a>
        );
    },
);

export default DropLink;
